// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu-module__font-s-10___X4cAX {
  font-size: 10px !important;
}

.Menu-module__font-s-12___wzSEZ {
  font-size: 12px !important;
}

.Menu-module__font-s-13___QpP__ {
  font-size: 13px !important;
}

.Menu-module__font-s-14___EA2Vq {
  font-size: 14px !important;
}

.Menu-module__font-s-15___vCnIA {
  font-size: 15px !important;
}

.Menu-module__font-s-16___lINZU {
  font-size: 16px !important;
}

.Menu-module__font-s-18___Zc5vZ {
  font-size: 18px !important;
}

.Menu-module__font-s-20___rhMFO {
  font-size: 20px !important;
}

.Menu-module__font-s-22___D721f {
  font-size: 22px !important;
}

.Menu-module__font-s-28___FWvpP {
  font-size: 28px !important;
}

.Menu-module__font-w-400___Xa484 {
  font-weight: 400 !important;
}

.Menu-module__font-w-500___bMY1L {
  font-weight: 500 !important;
}

.Menu-module__font-w-600___XB801 {
  font-weight: 600 !important;
}

.Menu-module__font-w-700___iEsBb {
  font-weight: 700 !important;
}

.Menu-module__p-5___Vo2_i {
  padding: 5px !important;
}

.Menu-module__p-12___guFBA {
  padding: 12px !important;
}

.Menu-module__p-16___fyoG3 {
  padding: 16px !important;
}

.Menu-module__p-30____cS8g {
  padding: 30px !important;
}

.Menu-module__p-b-0___zJxTH {
  padding-bottom: 0 !important;
}

.Menu-module__p-b-5___LvV0v {
  padding-bottom: 5px !important;
}

.Menu-module__p-b-10___mFuau {
  padding-bottom: 10px !important;
}

.Menu-module__p-b-12___AAdtY {
  padding-bottom: 12px !important;
}

.Menu-module__p-b-16___PcOjO {
  padding-bottom: 16px !important;
}

.Menu-module__p-b-18___FTT5c {
  padding-bottom: 18px !important;
}

.Menu-module__p-b-20___7Uh3z {
  padding-bottom: 20px !important;
}

.Menu-module__p-b-25___I5Vok {
  padding-bottom: 25px !important;
}

.Menu-module__p-b-30___ykteW {
  padding-bottom: 30px !important;
}

.Menu-module__p-b-50___uEmBL {
  padding-bottom: 50px !important;
}

.Menu-module__p-t-0___BeXSZ {
  padding-top: 0 !important;
}

.Menu-module__p-t-12___Ya1Wq {
  padding-top: 12px !important;
}

.Menu-module__p-t-16___v_vkY {
  padding-top: 16px !important;
}

.Menu-module__p-t-18___hPufJ {
  padding-top: 18px !important;
}

.Menu-module__p-t-20____qqZ0 {
  padding-top: 20px !important;
}

.Menu-module__p-t-30___p2PAD {
  padding-top: 30px !important;
}

.Menu-module__p-t-40___u2yCk {
  padding-top: 40px !important;
}

.Menu-module__p-t-50___QZonh {
  padding-top: 50px !important;
}

.Menu-module__p-l-20___w8dwc {
  padding-left: 20px !important;
}

.Menu-module__p-l-30___tUPpV {
  padding-left: 30px !important;
}

.Menu-module__p-l-40___Cng8I {
  padding-left: 40px !important;
}

.Menu-module__p-r-16___C2PMq {
  padding-right: 16px !important;
}

.Menu-module__p-r-20___igQjA {
  padding-right: 20px !important;
}

.Menu-module__p-r-30___EOp1C {
  padding-right: 30px !important;
}

.Menu-module__p-r-50___ToPvp {
  padding-right: 50px !important;
}

.Menu-module__p-r-60___Y4ffb {
  padding-right: 60px !important;
}

.Menu-module__m-b-1___dIi1w {
  margin-bottom: 1px !important;
}

.Menu-module__m-b-2___CmAHV {
  margin-bottom: 2px !important;
}

.Menu-module__m-b-6___cVkdF {
  margin-bottom: 6px !important;
}

.Menu-module__m-b-8___tWtan {
  margin-bottom: 8px !important;
}

.Menu-module__m-b-10___AxVtx {
  margin-bottom: 10px !important;
}

.Menu-module__m-b-14____W0it {
  margin-bottom: 14px !important;
}

.Menu-module__m-b-16___k4BNr {
  margin-bottom: 16px !important;
}

.Menu-module__m-b-20___PcYEc {
  margin-bottom: 20px !important;
}

.Menu-module__m-b-22___Bw0dS {
  margin-bottom: 22px !important;
}

.Menu-module__m-b-24___yu7U3 {
  margin-bottom: 24px !important;
}

.Menu-module__m-b-30___HR0yu {
  margin-bottom: 30px !important;
}

.Menu-module__m-b-32____TZZ9 {
  margin-bottom: 32px !important;
}

.Menu-module__m-b-40___IIjUR {
  margin-bottom: 40px !important;
}

.Menu-module__m-t-2___U5JUj {
  margin-top: 2px !important;
}

.Menu-module__m-t-3___gtv3y {
  margin-top: 3px !important;
}

.Menu-module__m-t-4___lWjHU {
  margin-top: 4px !important;
}

.Menu-module__m-t-5___Qb3bX {
  margin-top: 5px !important;
}

.Menu-module__m-t-8___CXoeH {
  margin-top: 8px !important;
}

.Menu-module__m-t-10___BupHG {
  margin-top: 10px !important;
}

.Menu-module__m-t-15___WXj1g {
  margin-top: 15px !important;
}

.Menu-module__m-t-16___D9hV2 {
  margin-top: 16px !important;
}

.Menu-module__m-t-20___gViR7 {
  margin-top: 20px !important;
}

.Menu-module__m-t-22___AwltS {
  margin-top: 22px !important;
}

.Menu-module__m-t-30___TfaCs {
  margin-top: 30px !important;
}

.Menu-module__m-t-32___NM6r7 {
  margin-top: 32px !important;
}

.Menu-module__m-l-auto___fcQIZ {
  margin-left: auto !important;
}

.Menu-module__m-l-4___wC8ya {
  margin-left: 4px !important;
}

.Menu-module__m-l-5___ImUKJ {
  margin-left: 5px !important;
}

.Menu-module__m-l-6___qm93r {
  margin-left: 6px !important;
}

.Menu-module__m-l-8___XJI5R {
  margin-left: 8px !important;
}

.Menu-module__m-l-10___ARnN8 {
  margin-left: 10px !important;
}

.Menu-module__m-l-16___xkjgu {
  margin-left: 16px !important;
}

.Menu-module__m-l-20___KSA7Z {
  margin-left: 20px !important;
}

.Menu-module__m-l-24___GDson {
  margin-left: 24px !important;
}

.Menu-module__m-l-30___aOXJ3 {
  margin-left: 30px !important;
}

.Menu-module__m-l-35___xTE0Q {
  margin-left: 35px !important;
}

.Menu-module__m-l-40___qyGVv {
  margin-left: 40px !important;
}

.Menu-module__m-r-8___TZVfN {
  margin-right: 8px !important;
}

.Menu-module__m-r-10___jqrXX {
  margin-right: 10px !important;
}

.Menu-module__m-r-16____UeT8 {
  margin-right: 16px !important;
}

.Menu-module__m-r-20___e8UOw {
  margin-right: 20px !important;
}

.Menu-module__m-r-24___hObWO {
  margin-right: 24px !important;
}

.Menu-module__m-r-30___gwc5d {
  margin-right: 30px !important;
}

.Menu-module__m-r-40___bLrMY {
  margin-right: 40px !important;
}

.Menu-module__border-r-3___X8zPt {
  border-radius: 3px !important;
}

.Menu-module__border-r-4___FyjqZ {
  border-radius: 4px !important;
}

.Menu-module__border-r-6___YCLgp {
  border-radius: 6px !important;
}

.Menu-module__border-r-10___CpDW6 {
  border-radius: 10px !important;
}

.Menu-module__border-r-12___N0iEN {
  border-radius: 12px !important;
}

.Menu-module__border-r-16___QhPtE {
  border-radius: 16px !important;
}

.Menu-module__border-r-50___SN4o8 {
  border-radius: 50% !important;
}

.Menu-module__primary-border___XffcE {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Menu-module__primary-border-b___HGYmx {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Menu-module__primary-border-t___Wv98Y {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Menu-module__primary-border-l___aXjPU {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Menu-module__primary-border-r___P3Po8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Menu-module__secondary-border___QiFMc {
  border: 1px solid #637768;
}

.Menu-module__secondary-border-b___cx_oh {
  border-bottom: 1px solid #637768;
}

.Menu-module__secondary-border-t___dqQEq {
  border-top: 1px solid #637768;
}

.Menu-module__secondary-border-l___uIBbG {
  border-left: 1px solid #637768;
}

.Menu-module__secondary-border-r___KX19W {
  border-right: 1px solid #637768;
}

.Menu-module__gap-0___OoJ0a {
  gap: 0 !important;
}

.Menu-module__gap-2___hfLs7 {
  gap: 2px !important;
}

.Menu-module__gap-4___Us94G {
  gap: 4px !important;
}

.Menu-module__gap-5___K2YPI {
  gap: 5px !important;
}

.Menu-module__gap-6___zNbzZ {
  gap: 6px !important;
}

.Menu-module__gap-8___KtAyi {
  gap: 8px !important;
}

.Menu-module__gap-10___uj5PM {
  gap: 10px !important;
}

.Menu-module__gap-12___i9yxO {
  gap: 12px !important;
}

.Menu-module__gap-14____sO7t {
  gap: 14px !important;
}

.Menu-module__gap-16___ZsR8i {
  gap: 16px !important;
}

.Menu-module__gap-18___NsBxn {
  gap: 18px !important;
}

.Menu-module__gap-20___SIDOa {
  gap: 20px !important;
}

.Menu-module__gap-24___fgAk0 {
  gap: 24px !important;
}

.Menu-module__gap-26___jCZQ8 {
  gap: 26px !important;
}

.Menu-module__gap-30___QYVDo {
  gap: 30px !important;
}

.Menu-module__gap-32___R2Tf9 {
  gap: 32px !important;
}

.Menu-module__gap-40___VGJdB {
  gap: 40px !important;
}

.Menu-module__gap-50___Jg4tK {
  gap: 50px !important;
}

.Menu-module__flex-1___fPXol {
  flex: 1;
}

.Menu-module__flex-none___u8Qmp {
  flex: none !important;
}

.Menu-module__flex-column___IBEVi {
  display: flex;
  flex-direction: column !important;
}

.Menu-module__flex-row___yrmgP {
  display: flex;
  flex-direction: row !important;
}

.Menu-module__vertically-centered___IWvhX {
  display: flex;
  align-items: center !important;
}

.Menu-module__horizontally-centered___vGR99 {
  display: flex;
  justify-content: center !important;
}

.Menu-module__horizontally-end___qizwd {
  display: flex;
  justify-content: end !important;
}

.Menu-module__vertically-start___ubDpD {
  display: flex;
  align-items: start !important;
}

.Menu-module__space-between___SDHmY {
  display: flex;
  justify-content: space-between !important;
}

.Menu-module__flex-wrap___P5lPu {
  flex-wrap: wrap !important;
}

.Menu-module__height-100___krjhK {
  height: 100%;
}

.Menu-module__width-50___vE6XF {
  width: 50% !important;
}

.Menu-module__width-100___jreNq {
  width: 100%;
}

.Menu-module__cursor-pointer___AmNFn {
  cursor: pointer;
}

.Menu-module__cursor-not-allowed___YLvRa {
  cursor: not-allowed !important;
}

.Menu-module__absolute-centered___jH71H {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Menu-module__absolute___Qx3SQ {
  position: absolute;
}

.Menu-module__relative___Mx1cu {
  position: relative;
}

.Menu-module__fixed___LKJR5 {
  position: fixed;
}

.Menu-module__visible___Kk9s4 {
  opacity: 1;
}

.Menu-module__invisible___KsIQN {
  opacity: 0;
}

.Menu-module__col-90___ZSV1j {
  width: 90% !important;
}

.Menu-module__col-auto___sfiP2 {
  width: auto !important;
}

.Menu-module__medical-tabs___z3JNS {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Menu-module__medical-table-new___NhYwS {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Menu-module__medical-table-new___NhYwS:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Menu-module__medical-table-new___NhYwS::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Menu-module__medical-table-new___NhYwS::-webkit-scrollbar-track {
  display: none;
}
.Menu-module__medical-table-new___NhYwS.Menu-module__no-pagination___dpOkr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Menu-module__medical-table-new___NhYwS.Menu-module__no-pagination___dpOkr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Menu-module__medical-table-new___NhYwS.Menu-module__no-pagination___dpOkr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Menu-module__medical-table-new___NhYwS.Menu-module__no-pagination___dpOkr::-webkit-scrollbar-track {
  display: none;
}

.Menu-module__medical-table-empty___l1JRR {
  padding: 14px 40px !important;
}

.Menu-module__icon-btn___ekqZ0 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Menu-module__search-icon___F0rtg {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Menu-module__disable-select___YbU4R {
  user-select: none;
}

.Menu-module__break-word___cn3sp {
  word-break: break-word;
}

.Menu-module__popup-clear-btn___w_DfQ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Menu-module__scroll-m-b-20___tHdIx {
  scroll-margin-bottom: 20px;
}

.Menu-module__buttonWrapper___spWFQ {
  display: flex;
  cursor: pointer;
  width: fit-content;
  position: relative;
}
.Menu-module__buttonWrapper___spWFQ.Menu-module__disabled___CSKNV {
  opacity: 0.5;
  cursor: not-allowed;
}
.Menu-module__buttonWrapper___spWFQ .Menu-module__icon___gKCi0 {
  right: 0;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
}
.Menu-module__buttonWrapper___spWFQ .Menu-module__icon___gKCi0.Menu-module__up___gquQO {
  transform: translateY(-50%) rotate(180deg);
}

.Menu-module__paper___yn8Ve {
  box-shadow: 0 0 2px 0 #375844;
  background-color: white;
  pointer-events: auto;
  overflow-y: scroll;
  z-index: 100;
}
.Menu-module__paper___yn8Ve .Menu-module__button___mxI1F {
  width: 100%;
  padding: 13px;
  font-size: 14px !important;
  border-radius: 0 !important;
  justify-content: flex-start !important;
}
.Menu-module__paper___yn8Ve .Menu-module__button___mxI1F > img {
  width: 15px;
  height: 15px;
}
.Menu-module__paper___yn8Ve .Menu-module__button___mxI1F:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;
}
.Menu-module__paper___yn8Ve .Menu-module__statusOption___Sx_Tq {
  cursor: pointer;
  padding: 8px 10px;
}
.Menu-module__paper___yn8Ve .Menu-module__statusOption___Sx_Tq:hover, .Menu-module__paper___yn8Ve .Menu-module__statusOption___Sx_Tq.Menu-module__selected___PeHuA {
  background-color: #f1f3e7;
}
.Menu-module__paper___yn8Ve .Menu-module__customOption___YYGe4 {
  cursor: pointer;
}
.Menu-module__paper___yn8Ve .Menu-module__customOption___YYGe4:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;
}
.Menu-module__paper___yn8Ve .Menu-module__customOption___YYGe4:hover, .Menu-module__paper___yn8Ve .Menu-module__customOption___YYGe4.Menu-module__selected___PeHuA {
  background-color: #f2f2f2;
}
.Menu-module__paper___yn8Ve .Menu-module__clearButton___Dw5MG {
  width: 100%;
}

.Menu-module__subPaper___zveyW {
  box-shadow: 0 0 2px 0 #375844;
  background-color: white;
  pointer-events: auto;
  overflow-y: scroll;
  z-index: 100;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2 {
  color: #375844;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  text-align: left;
  font-family: inherit !important;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2 .Menu-module__subOptionLabel___IZzLM {
  padding: 12px 14px;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2:hover {
  background-color: #f1f3e7;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2:disabled {
  opacity: 1;
  cursor: not-allowed;
}
.Menu-module__subPaper___zveyW .Menu-module__subOption___tu_l2:disabled .Menu-module__subOptionLabel___IZzLM {
  opacity: 0.5;
}
.Menu-module__subPaper___zveyW .Menu-module__backWrapper___H2EF5 {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 12px 14px;
}
.Menu-module__subPaper___zveyW .Menu-module__backWrapper___H2EF5:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.Menu-module__subPaper___zveyW .Menu-module__backWrapper___H2EF5 .Menu-module__backIcon___HJO8N {
  width: 15px;
  height: 15px;
}
.Menu-module__subPaper___zveyW .Menu-module__backWrapper___H2EF5.Menu-module__rotate___xgRVa {
  flex-direction: row-reverse !important;
  justify-content: flex-end;
}
.Menu-module__subPaper___zveyW .Menu-module__backWrapper___H2EF5.Menu-module__rotate___xgRVa .Menu-module__backIcon___HJO8N {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Menu/Menu.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,mBAAA;AA8pBJ;AA3pBE;EACE,QAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;AA6pBJ;AA3pBI;EACE,0CAAA;AA6pBN;;AAxpBA;EACE,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AA2pBF;AAzpBE;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,2BAAA;EACA,sCAAA;AA2pBJ;AAzpBI;EACE,WAAA;EACA,YAAA;AA2pBN;AAxpBI;EACE,yDAAA;AA0pBN;AAtpBE;EACE,eAAA;EACA,iBAAA;AAwpBJ;AAtpBI;EAEE,yBAAA;AAupBN;AAnpBE;EACE,eAAA;AAqpBJ;AAnpBI;EACE,yDAAA;AAqpBN;AAlpBI;EAEE,yBAAA;AAmpBN;AA/oBE;EACE,WAAA;AAipBJ;;AA7oBA;EACE,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AAgpBF;AA9oBE;EACE,cAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;AAgpBJ;AA9oBI;EACE,kBAAA;AAgpBN;AA7oBI;EACE,yBAAA;AA+oBN;AA5oBI;EACE,yDAAA;AA8oBN;AA3oBI;EACE,UAAA;EACA,mBAAA;AA6oBN;AA3oBM;EACE,YAAA;AA6oBR;AAxoBE;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;AA0oBJ;AAxoBI;EACE,oCAAA;AA0oBN;AAvoBI;EACE,WAAA;EACA,YAAA;AAyoBN;AAtoBI;EACE,sCAAA;EACA,yBAAA;AAwoBN;AAtoBM;EACE,yBAAA;AAwoBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.buttonWrapper {\n  display: flex;\n  cursor: pointer;\n  width: fit-content;\n  position: relative;\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .icon {\n    right: 0;\n    top: 50%;\n    position: absolute;\n    transform: translateY(-50%);\n\n    &.up {\n      transform: translateY(-50%) rotate(180deg);\n    }\n  }\n}\n\n.paper {\n  box-shadow: 0 0 2px 0 get-color(greenNew, dark);\n  background-color: get-color(white);\n  pointer-events: auto;\n  overflow-y: scroll;\n  z-index: 100;\n\n  .button {\n    width: 100%;\n    padding: 13px;\n    font-size: 14px !important;\n    border-radius: 0 !important;\n    justify-content: flex-start !important;\n\n    & > img {\n      width: 15px;\n      height: 15px;\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;\n    }\n  }\n\n  .statusOption {\n    cursor: pointer;\n    padding: 8px 10px;\n\n    &:hover,\n    &.selected {\n      background-color: get-color(greenNew, lighter);\n    }\n  }\n\n  .customOption {\n    cursor: pointer;\n\n    &:not(:last-child) {\n      border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;\n    }\n\n    &:hover,\n    &.selected {\n      background-color: get-color(gray, lightest);\n    }\n  }\n\n  .clearButton {\n    width: 100%;\n  }\n}\n\n.subPaper {\n  box-shadow: 0 0 2px 0 get-color(greenNew, dark);\n  background-color: get-color(white);\n  pointer-events: auto;\n  overflow-y: scroll;\n  z-index: 100;\n\n  .subOption {\n    color: get-color(greenNew, dark);\n    background: rgba(0, 0, 0, 0.3);\n    width: 100%;\n    text-align: left;\n    font-family: inherit !important;\n\n    .subOptionLabel {\n      padding: 12px 14px;\n    }\n\n    &:hover {\n      background-color: get-color(greenNew, lighter);\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid rgba(91, 91, 91, 0.2) !important;\n    }\n\n    &:disabled {\n      opacity: 1;\n      cursor: not-allowed;\n\n      .subOptionLabel {\n        opacity: 0.5;\n      }\n    }\n  }\n\n  .backWrapper {\n    background-color: rgba(0, 0, 0, 0.6);\n    color: get-color(white);\n    padding: 12px 14px;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.7);\n    }\n\n    .backIcon {\n      width: 15px;\n      height: 15px;\n    }\n\n    &.rotate {\n      flex-direction: row-reverse !important;\n      justify-content: flex-end;\n\n      .backIcon {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Menu-module__font-s-10___X4cAX`,
	"fontS12": `Menu-module__font-s-12___wzSEZ`,
	"fontS13": `Menu-module__font-s-13___QpP__`,
	"fontS14": `Menu-module__font-s-14___EA2Vq`,
	"fontS15": `Menu-module__font-s-15___vCnIA`,
	"fontS16": `Menu-module__font-s-16___lINZU`,
	"fontS18": `Menu-module__font-s-18___Zc5vZ`,
	"fontS20": `Menu-module__font-s-20___rhMFO`,
	"fontS22": `Menu-module__font-s-22___D721f`,
	"fontS28": `Menu-module__font-s-28___FWvpP`,
	"fontW400": `Menu-module__font-w-400___Xa484`,
	"fontW500": `Menu-module__font-w-500___bMY1L`,
	"fontW600": `Menu-module__font-w-600___XB801`,
	"fontW700": `Menu-module__font-w-700___iEsBb`,
	"p5": `Menu-module__p-5___Vo2_i`,
	"p12": `Menu-module__p-12___guFBA`,
	"p16": `Menu-module__p-16___fyoG3`,
	"p30": `Menu-module__p-30____cS8g`,
	"pB0": `Menu-module__p-b-0___zJxTH`,
	"pB5": `Menu-module__p-b-5___LvV0v`,
	"pB10": `Menu-module__p-b-10___mFuau`,
	"pB12": `Menu-module__p-b-12___AAdtY`,
	"pB16": `Menu-module__p-b-16___PcOjO`,
	"pB18": `Menu-module__p-b-18___FTT5c`,
	"pB20": `Menu-module__p-b-20___7Uh3z`,
	"pB25": `Menu-module__p-b-25___I5Vok`,
	"pB30": `Menu-module__p-b-30___ykteW`,
	"pB50": `Menu-module__p-b-50___uEmBL`,
	"pT0": `Menu-module__p-t-0___BeXSZ`,
	"pT12": `Menu-module__p-t-12___Ya1Wq`,
	"pT16": `Menu-module__p-t-16___v_vkY`,
	"pT18": `Menu-module__p-t-18___hPufJ`,
	"pT20": `Menu-module__p-t-20____qqZ0`,
	"pT30": `Menu-module__p-t-30___p2PAD`,
	"pT40": `Menu-module__p-t-40___u2yCk`,
	"pT50": `Menu-module__p-t-50___QZonh`,
	"pL20": `Menu-module__p-l-20___w8dwc`,
	"pL30": `Menu-module__p-l-30___tUPpV`,
	"pL40": `Menu-module__p-l-40___Cng8I`,
	"pR16": `Menu-module__p-r-16___C2PMq`,
	"pR20": `Menu-module__p-r-20___igQjA`,
	"pR30": `Menu-module__p-r-30___EOp1C`,
	"pR50": `Menu-module__p-r-50___ToPvp`,
	"pR60": `Menu-module__p-r-60___Y4ffb`,
	"mB1": `Menu-module__m-b-1___dIi1w`,
	"mB2": `Menu-module__m-b-2___CmAHV`,
	"mB6": `Menu-module__m-b-6___cVkdF`,
	"mB8": `Menu-module__m-b-8___tWtan`,
	"mB10": `Menu-module__m-b-10___AxVtx`,
	"mB14": `Menu-module__m-b-14____W0it`,
	"mB16": `Menu-module__m-b-16___k4BNr`,
	"mB20": `Menu-module__m-b-20___PcYEc`,
	"mB22": `Menu-module__m-b-22___Bw0dS`,
	"mB24": `Menu-module__m-b-24___yu7U3`,
	"mB30": `Menu-module__m-b-30___HR0yu`,
	"mB32": `Menu-module__m-b-32____TZZ9`,
	"mB40": `Menu-module__m-b-40___IIjUR`,
	"mT2": `Menu-module__m-t-2___U5JUj`,
	"mT3": `Menu-module__m-t-3___gtv3y`,
	"mT4": `Menu-module__m-t-4___lWjHU`,
	"mT5": `Menu-module__m-t-5___Qb3bX`,
	"mT8": `Menu-module__m-t-8___CXoeH`,
	"mT10": `Menu-module__m-t-10___BupHG`,
	"mT15": `Menu-module__m-t-15___WXj1g`,
	"mT16": `Menu-module__m-t-16___D9hV2`,
	"mT20": `Menu-module__m-t-20___gViR7`,
	"mT22": `Menu-module__m-t-22___AwltS`,
	"mT30": `Menu-module__m-t-30___TfaCs`,
	"mT32": `Menu-module__m-t-32___NM6r7`,
	"mLAuto": `Menu-module__m-l-auto___fcQIZ`,
	"mL4": `Menu-module__m-l-4___wC8ya`,
	"mL5": `Menu-module__m-l-5___ImUKJ`,
	"mL6": `Menu-module__m-l-6___qm93r`,
	"mL8": `Menu-module__m-l-8___XJI5R`,
	"mL10": `Menu-module__m-l-10___ARnN8`,
	"mL16": `Menu-module__m-l-16___xkjgu`,
	"mL20": `Menu-module__m-l-20___KSA7Z`,
	"mL24": `Menu-module__m-l-24___GDson`,
	"mL30": `Menu-module__m-l-30___aOXJ3`,
	"mL35": `Menu-module__m-l-35___xTE0Q`,
	"mL40": `Menu-module__m-l-40___qyGVv`,
	"mR8": `Menu-module__m-r-8___TZVfN`,
	"mR10": `Menu-module__m-r-10___jqrXX`,
	"mR16": `Menu-module__m-r-16____UeT8`,
	"mR20": `Menu-module__m-r-20___e8UOw`,
	"mR24": `Menu-module__m-r-24___hObWO`,
	"mR30": `Menu-module__m-r-30___gwc5d`,
	"mR40": `Menu-module__m-r-40___bLrMY`,
	"borderR3": `Menu-module__border-r-3___X8zPt`,
	"borderR4": `Menu-module__border-r-4___FyjqZ`,
	"borderR6": `Menu-module__border-r-6___YCLgp`,
	"borderR10": `Menu-module__border-r-10___CpDW6`,
	"borderR12": `Menu-module__border-r-12___N0iEN`,
	"borderR16": `Menu-module__border-r-16___QhPtE`,
	"borderR50": `Menu-module__border-r-50___SN4o8`,
	"primaryBorder": `Menu-module__primary-border___XffcE`,
	"primaryBorderB": `Menu-module__primary-border-b___HGYmx`,
	"primaryBorderT": `Menu-module__primary-border-t___Wv98Y`,
	"primaryBorderL": `Menu-module__primary-border-l___aXjPU`,
	"primaryBorderR": `Menu-module__primary-border-r___P3Po8`,
	"secondaryBorder": `Menu-module__secondary-border___QiFMc`,
	"secondaryBorderB": `Menu-module__secondary-border-b___cx_oh`,
	"secondaryBorderT": `Menu-module__secondary-border-t___dqQEq`,
	"secondaryBorderL": `Menu-module__secondary-border-l___uIBbG`,
	"secondaryBorderR": `Menu-module__secondary-border-r___KX19W`,
	"gap0": `Menu-module__gap-0___OoJ0a`,
	"gap2": `Menu-module__gap-2___hfLs7`,
	"gap4": `Menu-module__gap-4___Us94G`,
	"gap5": `Menu-module__gap-5___K2YPI`,
	"gap6": `Menu-module__gap-6___zNbzZ`,
	"gap8": `Menu-module__gap-8___KtAyi`,
	"gap10": `Menu-module__gap-10___uj5PM`,
	"gap12": `Menu-module__gap-12___i9yxO`,
	"gap14": `Menu-module__gap-14____sO7t`,
	"gap16": `Menu-module__gap-16___ZsR8i`,
	"gap18": `Menu-module__gap-18___NsBxn`,
	"gap20": `Menu-module__gap-20___SIDOa`,
	"gap24": `Menu-module__gap-24___fgAk0`,
	"gap26": `Menu-module__gap-26___jCZQ8`,
	"gap30": `Menu-module__gap-30___QYVDo`,
	"gap32": `Menu-module__gap-32___R2Tf9`,
	"gap40": `Menu-module__gap-40___VGJdB`,
	"gap50": `Menu-module__gap-50___Jg4tK`,
	"flex1": `Menu-module__flex-1___fPXol`,
	"flexNone": `Menu-module__flex-none___u8Qmp`,
	"flexColumn": `Menu-module__flex-column___IBEVi`,
	"flexRow": `Menu-module__flex-row___yrmgP`,
	"verticallyCentered": `Menu-module__vertically-centered___IWvhX`,
	"horizontallyCentered": `Menu-module__horizontally-centered___vGR99`,
	"horizontallyEnd": `Menu-module__horizontally-end___qizwd`,
	"verticallyStart": `Menu-module__vertically-start___ubDpD`,
	"spaceBetween": `Menu-module__space-between___SDHmY`,
	"flexWrap": `Menu-module__flex-wrap___P5lPu`,
	"height100": `Menu-module__height-100___krjhK`,
	"width50": `Menu-module__width-50___vE6XF`,
	"width100": `Menu-module__width-100___jreNq`,
	"cursorPointer": `Menu-module__cursor-pointer___AmNFn`,
	"cursorNotAllowed": `Menu-module__cursor-not-allowed___YLvRa`,
	"absoluteCentered": `Menu-module__absolute-centered___jH71H`,
	"absolute": `Menu-module__absolute___Qx3SQ`,
	"relative": `Menu-module__relative___Mx1cu`,
	"fixed": `Menu-module__fixed___LKJR5`,
	"visible": `Menu-module__visible___Kk9s4`,
	"invisible": `Menu-module__invisible___KsIQN`,
	"col90": `Menu-module__col-90___ZSV1j`,
	"colAuto": `Menu-module__col-auto___sfiP2`,
	"medicalTabs": `Menu-module__medical-tabs___z3JNS`,
	"medicalTableNew": `Menu-module__medical-table-new___NhYwS`,
	"noPagination": `Menu-module__no-pagination___dpOkr`,
	"medicalTableEmpty": `Menu-module__medical-table-empty___l1JRR`,
	"iconBtn": `Menu-module__icon-btn___ekqZ0`,
	"searchIcon": `Menu-module__search-icon___F0rtg`,
	"disableSelect": `Menu-module__disable-select___YbU4R`,
	"breakWord": `Menu-module__break-word___cn3sp`,
	"popupClearBtn": `Menu-module__popup-clear-btn___w_DfQ`,
	"scrollMB20": `Menu-module__scroll-m-b-20___tHdIx`,
	"buttonWrapper": `Menu-module__buttonWrapper___spWFQ`,
	"disabled": `Menu-module__disabled___CSKNV`,
	"icon": `Menu-module__icon___gKCi0`,
	"up": `Menu-module__up___gquQO`,
	"paper": `Menu-module__paper___yn8Ve`,
	"button": `Menu-module__button___mxI1F`,
	"statusOption": `Menu-module__statusOption___Sx_Tq`,
	"selected": `Menu-module__selected___PeHuA`,
	"customOption": `Menu-module__customOption___YYGe4`,
	"clearButton": `Menu-module__clearButton___Dw5MG`,
	"subPaper": `Menu-module__subPaper___zveyW`,
	"subOption": `Menu-module__subOption___tu_l2`,
	"subOptionLabel": `Menu-module__subOptionLabel___IZzLM`,
	"backWrapper": `Menu-module__backWrapper___H2EF5`,
	"backIcon": `Menu-module__backIcon___HJO8N`,
	"rotate": `Menu-module__rotate___xgRVa`
};
module.exports = ___CSS_LOADER_EXPORT___;
